import { PiBroadcast } from 'react-icons/pi'
import { Alert } from 'components/FbUI/Alert'

export function LiveCampaignBanner() {
  return (
    <Alert
      color="info"
      icon={PiBroadcast}
      title="This campaign is live."
      description="Changes will apply to future sends only. Contacts who have already received a step won't be affected."
    />
  )
}
